import React from "react";

const ASP_Procedures = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Procedures</h1>
      <p>This is the ASP Procedures page content.</p>
    </div>
  );
};

export default ASP_Procedures;
